module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.modalVisible === 'export-table') ? _c('layout-general', {
    on: {
      "close": function($event) {
        return _vm.modalClose()
      }
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('general.actions.export')) + " " + _vm._s(_vm.$t('modal.export_table.answer_table')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('h4', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('modal.export_table.insert')) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.modalClose()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.reportExport(_vm.email)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.actions.export')) + " " + _vm._s(_vm.$t('general.labels.table')) + "\n    ")])])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-6e6fb621!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ExportTable.vue
 ** module id = 854
 ** module chunks = 1
 **/